import { useServiceStore, useUserService } from "..";

export function usePermissions(): string[] {
  const UserService = useUserService();

  return useServiceStore(UserService, (state) => state.permissions);
}
